<div class="menu-item__row">
  <a class="menu-item__link"
     #menuLink
     [attr.href]="href"
     [attr.target]="externalHrefTarget"
     [attr.tabindex]="href ? null : 0"
     [attr.role]="href ? null : 'button'"
     [attr.aria-expanded]="!href && hasChildren ? expanded : null"
     [attr.aria-controls]="hasChildren ? flyoutId : null"
     [attr.aria-label]="compact && label ? label : null"
     [attr.aria-current]="active && href ? 'page' : null"
     [ngfTooltip]="label"
     [ngfTooltipDisabled]="!compact || !label"
     (click)="handleLinkClick($event)"
     (keydown)="handleKeydown($event)">
    <span class="menu-item__icon">
      @if (svgIcon) {
        <mat-icon [svgIcon]="svgIcon" aria-hidden="true"></mat-icon>
      } @else {
        @if (icon) {
          <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
        }
      }
    </span>

    <span class="menu-item__text">
      <ng-content></ng-content>
    </span>

    @if (hasChildren) {
      <mat-icon class="menu-item__arrow" aria-hidden="true">
        {{ expanded ? 'expand_less' : 'expand_more' }}
      </mat-icon>
    }
  </a>
</div>

<div class="menu-item__children"
     #flyout
     [id]="flyoutId"
     [class.menu-item__children--hidden]="!expanded"
     [attr.role]="compact ? 'dialog' : null"
     [attr.aria-labelledby]="compact && label ? flyoutTitleId : null"
     (click)="handleChildrenClick($event)"
     (keydown)="handleFlyoutKeydown($event)">
  @if (label) {
    <div class="menu-item__flyout-title" [id]="flyoutTitleId">{{ label }}</div>
  }
  <ul class="menu-item__children-list">
    <ng-content select="ngf-tester-navigation-sidebar-menu-item-child"></ng-content>
  </ul>
</div>
